import { render, staticRenderFns } from "./VideoListForm.vue?vue&type=template&id=0875f417&scoped=true"
import script from "./VideoListForm.vue?vue&type=script&lang=js"
export * from "./VideoListForm.vue?vue&type=script&lang=js"
import style0 from "./VideoListForm.vue?vue&type=style&index=0&id=0875f417&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0875f417",
  null
  
)

export default component.exports